import React, { useState } from "react";
import PropTypes from "prop-types";
import { usePopper } from "react-popper";
import styled, { keyframes } from "styled-components";

import { colors } from "../../theme";

const appear = keyframes`
  from {
    opacity: 0;
    transform: translateY(-15px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;
const Container = styled.div`
  > div {
    animation: ${appear} 0.2s linear;
    background: white;
    border-radius: 4px;
    box-shadow: 0 4px 11px rgba(0, 0, 0, 0.1);
    color: ${colors.textColor};
    padding: 8px 14px;
  }

  z-index: 30000;
`;

function Tooltip({ children, refElement, className }) {
  const [popperElement, setPopperElement] = useState(null);
  const { styles, attributes } = usePopper(refElement, popperElement, {
    placement: "top",
    modifiers: [{ name: "offset", options: { offset: [0, 15] } }],
  });

  return (
    <Container
      className={className}
      ref={setPopperElement}
      style={styles.popper}
      {...attributes.popper}
    >
      <div>{children}</div>
    </Container>
  );
}

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  refElement: PropTypes.object,
  className: PropTypes.string,
};

export default Tooltip;
